import { Component, OnInit } from "@angular/core";
import { OrderService } from "../../../service/order.service";
import { InvoiceService } from "../../../service/invoice.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Message } from "primeng/components/common/api";
import { UserService } from "../../../shared/user.service";
import { flattenStyles } from "@angular/platform-browser/src/dom/dom_renderer";
import { invoiceData } from "../../../model/invoiceData.model";
import { Router } from "@angular/router";

@Component({
  selector: "app-customer-invoice-list",
  templateUrl: "./customer-invoice-list.component.html",
  styleUrls: ["./customer-invoice-list.component.css"],
})
export class CustomerInvoiceListComponent implements OnInit {
  invoices: any[];
  cols = [
    { field: "InvoiceType", header: "סוג מסמך", width: "100", priority: "" },
    { field: "InvoiceNumber", header: "מספר מסמך", width: "100", priority: "" },
    {
      field: "OrderNumber",
      header: "מספר הזמנה",
      width: "140",
      priority: "ui-p-2",
    },
    {
      field: "InvoicesInOrderCount",
      header: "מספר מסמכים בהזמנה",
      width: "70",
      priority: "ui-p-2",
    },
    {
      field: "InvoiceStatus",
      header: "סטטוס",
      width: "100",
      priority: "ui-p-2",
    },
    {
      field: "Notes",
      header: "הערות",
      width: "100",
      priority: "ui-p-2",
    },
    {
      field: "InvoiceDate",
      header: "תאריך מסמך",
      width: "100",
      priority: "ui-p-3",
    },
    // { field: 'Quantity', header: 'כמות', width: '80', priority: 'ui-p-6'   },
    // { field: 'UnitePrice', header: 'מחיר ליחידה', width: '80', priority: 'ui-p-6'   },
    // { field: 'Total', header: 'סה"כ', width: '80', priority: 'ui-p-6'   },
    {
      field: "TotalWithTax",
      header: 'סה"כ כולל מע"מ',
      width: "80",
      priority: "ui-p-6",
    },
    {
      field: "SupplierName",
      header: "שם ספק",
      width: "120",
      priority: "ui-p-6",
    },
  ];

  treatmentTypes: any[] = [
    { value: "0", label: "בכל שלבי טיפול", disabled: false },
    { value: "1", label: "ממתין לטיפולי", disabled: false },
  ];
  treatmentTypeSelected = this.treatmentTypes[1].value;

  filterOrderNumber: any;
  //filterSupplier: any;
  filterOrderStatus: any;
  filterDateFrom: any;
  filterDateTo: any;

  //suppliersOptions: any[] = [];
  orderStatusOptions: any[] = [];

  msgs: Message[] = [];

  suppliers: any = [];
  selectedSuppliers: any = []; //any[] = [];
  filteredSuppliers: any = []; //any[] = [];

  showInvoiceDetails: boolean = false;
  initInvoiceId: number = null;

  userDetails: any;

  showInvoicePreviewDialog: boolean = false;
  currentInvoiceDetails: any;

  showConfirmDialog: boolean = false;

  invoiceDetails: any[] = null;

  nextConfirmerSeleted: any;
  nextConfirmerNotes: any;

  havePermission = false;

  selectedInvoices: any[] = [];

  constructor(
    private orderService: OrderService,
    private invoiceService: InvoiceService,
    private userService: UserService,
    private router: Router
  ) {}

  searchSuppliers(event) {
    let query = event.query;
    this.filteredSuppliers = this.filterSuppliers(query, this.suppliers);
  }

  ngOnInit() {
    this.userService.getUserClaims().subscribe(
      (data: any) => {
        this.userDetails = data;
        console.log(this.userDetails);
        if (this.userDetails.ClientRoleCustomerPaymentConfirmOwnOnly) {
          this.treatmentTypeSelected = this.treatmentTypes[1].value;
          this.treatmentTypes.splice(0, 1);
        }
      },
      (err: HttpErrorResponse) => {
        this.userDetails = null;
      }
    );

    this.filterOrderNumber = null;

    //this.filterSupplier = null;
    this.selectedSuppliers = null;
    this.orderService.GetCustomerSuppliers().subscribe(
      (result) => {
        //(result: any) => {
        //this.suppliersOptions = result;
        this.suppliers = result;
      },
      (err: HttpErrorResponse) => {
        this.showMessage("error", "", "תקלה בקבלת רשימת ספקים ");
      }
    );

    this.filterOrderStatus = null;
    this.invoiceService.GetCustomerInvoiceStatuses().subscribe(
      (result: any) => {
        this.orderStatusOptions = result;
        // this.orderStatusOptions.unshift({ label: 'הכל', value: null });
      },
      (err: HttpErrorResponse) => {
        this.showMessage("error", "", "תקלה בקבלת רשימת סטטוסים ");
      }
    );

    let y =
      new Date().getMonth() < 3
        ? new Date().getFullYear() - 1
        : new Date().getFullYear();
    let fromD = new Date(y, 0, 1);
    //this.filterDateFrom = new Date(Date.UTC(fromD.getFullYear(), fromD.getMonth(), fromD.getDate()));
    this.filterDateTo = new Date();

    this.getCustomerInvoices();
  }

  getCustomerInvoices() {
    let invoiceFilter = {
      OrderNumber: this.filterOrderNumber,
      //SupplierId: this.filterSupplier ? this.filterSupplier.Id : null,
      SupplierId: this.selectedSuppliers ? this.selectedSuppliers.Id : null,
      InvoiceStatusId: this.filterOrderStatus,
      InvoiceDateFrom: this.filterDateFrom
        ? new Date(
            Date.UTC(
              this.filterDateFrom.getFullYear(),
              this.filterDateFrom.getMonth(),
              this.filterDateFrom.getDate()
            )
          )
        : null,
      InvoiceDateTo: this.filterDateTo
        ? new Date(
            Date.UTC(
              this.filterDateTo.getFullYear(),
              this.filterDateTo.getMonth(),
              this.filterDateTo.getDate()
            )
          )
        : null,
      TreatmentType: this.treatmentTypeSelected,
    };
    this.invoiceService.getCustomerInvoices(invoiceFilter).subscribe(
      (result: any) => {
        this.invoices = result;

        console.log(this.invoices);
      },
      (err: HttpErrorResponse) => {
        let errMessage =
          err.error && err.error.ExceptionMessage
            ? err.error.ExceptionMessage
            : "תקלה בקבלת נתונים ";
        this.showMessage("error", "", errMessage);
      }
    );
  }

  openInvoiceDetails(item) {
    // alert(item.InvoiceIdLink);
    this.initInvoiceId = item.InvoiceId;
    this.showInvoiceDetails = true;
  }

  closeInvoiceDetails() {
    this.getCustomerInvoices();
    this.initInvoiceId = null;
    this.showInvoiceDetails = false;
  }

  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({
      severity: type,
      summary: summaryMessage,
      detail: message,
    });
  }

  showSuccess() {
    this.msgs = [];
    this.msgs.push({
      severity: "success",
      summary: "",
      detail: " העדכון נשמר בהצלחה",
    });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: "error", summary: "", detail: " שגיאה בעדכון" });
  }

  filterSuppliers(query, suppliers: any[]): any[] {
    let filtered: any[] = [];
    for (let i = 0; i < suppliers.length; i++) {
      let supplier = suppliers[i];
      if (
        supplier.Name.toLowerCase().indexOf(query.toLowerCase()) >= 0 ||
        supplier.EMail.toLowerCase().indexOf(query.toLowerCase()) >= 0
      ) {
        filtered.push(supplier);
      }
    }
    return filtered;
  }

  showFile(invoice) {
    this.currentInvoiceDetails = invoice;
    this.showInvoicePreviewDialog = true;
  }

  // CustomerConfirm() {
  //   let invoicesSelected = this.invoices.filter((f) => f.isChecked);
  //   if (invoicesSelected && invoicesSelected.length > 0) {
  //     this.invoiceDetails = invoicesSelected;
  //     this.showConfirmDialog = true;
  //   }

  // }

  // handleAllSelectedInvoices(statusChange: boolean) {
  //   if (!this.nextConfirmerSeleted) {
  //     this.showMessage("error", "", "חובה לבחור גורם מטפל הבא");
  //     return;
  //   }

  //   let confirmDataList: any[] = [];

  //   for (let index = 0; index < this.invoiceDetails.length; index++) {
  //     let confirmData = {
  //       InvoiceId: this.invoiceDetails[index].InvoiceId,
  //       NextConfirmer: this.nextConfirmerSeleted,
  //       Notes: this.nextConfirmerNotes,
  //     };

  //     confirmDataList.push(confirmData);

  //     this.invoiceService
  //       .confirmDataList(confirmDataList, statusChange)
  //       .subscribe(
  //         (result: any) => {
  //           this.showMessage("success", "", "פעולה בוצעה בהצלחה");
  //           this.showConfirmDialog = false;
  //           this.nextConfirmerSeleted = null;
  //           this.nextConfirmerNotes = null;
  //           this.getCustomerInvoices();
  //         },
  //         (err: HttpErrorResponse) => {
  //           let errMessage =
  //             err.error && err.error.ExceptionMessage
  //               ? err.error.ExceptionMessage
  //               : "תקלה בפעולת חתימה";
  //           this.showMessage("error", "", errMessage);
  //         }
  //       );
  //   }
  //   // alert("invoice id > " + this.invoiceDetails[index].InvoiceId + " added");
  // }

  handleAddInvoice = (invoice: any) => {
    if (invoice.isChecked) {
      // If the checkbox is checked, add the invoice to the array
      this.selectedInvoices.push(invoice);
    } else {
      // If the checkbox is unchecked, remove the invoice from the array
      const index = this.selectedInvoices.indexOf(invoice);
      if (index !== -1) {
        this.selectedInvoices.splice(index, 1);
      }
    }
  };

  CustomerConfirm = () => {
    this.invoiceDetails = this.selectedInvoices;
    this.showConfirmDialog = true;
  };

  handleAllSelectedInvoices(statusChange: boolean) {
    if (!this.nextConfirmerSeleted) {
      this.showMessage("error", "", "חובה לבחור גורם מטפל הבא");
      return;
    }

    let invoiceData: invoiceData[] = [];

    for (let index = 0; index < this.invoiceDetails.length; index++) {
      let singleInvoiceData: invoiceData = {
        InvoiceId: this.invoiceDetails[index].InvoiceId,
        NextConfirmer: this.nextConfirmerSeleted,
        Notes: this.nextConfirmerNotes,
      };

      invoiceData.push(singleInvoiceData);
    }

    console.log(invoiceData);

    this.invoiceService
      .confirmDataList(invoiceData, statusChange)
      .subscribe((response) => {
        // console.log(response);
        if (response == true) {
          this.showMessage("success", "", "פעולה בוצעה בהצלחה");
          this.showConfirmDialog = false;
          this.nextConfirmerSeleted = null;
          this.nextConfirmerNotes = null;
          this.selectedInvoices = [];
          this.invoiceDetails = [];
          this.getCustomerInvoices();
        } else {
          this.showMessage("error", "", "קרתה תקלה, נסה שוב במועד מאוחר יותר");
        }
      });
  }

  goToEquipmentSign = (item: any) => {
    console.log(item);
    const orderId = item.OrderId;

    const url = this.router.serializeUrl(
      this.router.createUrlTree(["/equipmentSign", orderId])
    );
    window.open(url, "_blank");
  };
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/invoice/customer-invoice/customer-invoice-list/customer-invoice-list.component.ts